import Checkbox from './checkbox.vue';

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/inputs/checkbox/index.js